"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _intlDesignUi = require("@tencent/intl-design-ui");
var _axios = _interopRequireDefault(require("axios"));
const MAX_SIZE = 2;
_axios.default.defaults.withCredentials = true;
_axios.default.defaults.crossDomain = true;
_axios.default.defaults.headers.post['Content-Type'] = 'application/json';
const dataURItoBase64Content = dataURI => {
  if (!dataURI || typeof dataURI !== 'string') return dataURI;
  const base64contentStr = dataURI.split(',')[1];
  return base64contentStr;
};
const alert = (tip, desc, btnTxt) => {
  _intlDesignUi.Modal.alert({
    size: 'small',
    icon: 'info-circle',
    title: tip,
    content: desc,
    btnOkMsg: btnTxt
  });
};
function Upload(props) {
  const onChange = props.onChange,
    data = props.data,
    name = props.name,
    uploadTxtObj = props.uploadTxtObj;
  const limitTxt = uploadTxtObj.limitTxt,
    tip = uploadTxtObj.tip,
    desc = uploadTxtObj.desc,
    btnTxt = uploadTxtObj.btnTxt,
    text = uploadTxtObj.text;
  const _React$useState = _react.default.useState(data || {}),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  const _React$useState3 = _react.default.useState(''),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    filePath = _React$useState4[0],
    setFilePath = _React$useState4[1];
  const handleChange = e => {
    const file = e.target.files[0];
    // 上传限制文件大小2M
    if (file.size / 1024 / 1024 > MAX_SIZE) {
      alert(tip, desc, btnTxt);
      return;
    }
    let filename = '';
    let fileBase64 = '';
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function (readRes) {
        const fileDataURL = readRes.target.result;
        fileBase64 = dataURItoBase64Content(fileDataURL);
        filename = file.name;
        (0, _axios.default)({
          method: 'post',
          url: '/render/api/configsolution/fileUpload',
          data: {
            fileName: filename,
            base64Data: fileBase64,
            app: 'ioc'
          }
        }).then(({
          data
        }) => {
          const code = data.code,
            _data$data = data.data,
            filePath = _data$data.filePath,
            _data$data$msg = _data$data.msg,
            msg = _data$data$msg === void 0 ? 'Upload failed, please try again' : _data$data$msg;
          if (code === 0 && filePath) {
            onChange(filePath);
            setFilePath(filePath);
            setInputValue(file);
          } else {
            alert(tip, msg, btnTxt);
          }
        }).catch(() => {
          alert(tip, 'Upload failed, please try again', btnTxt);
        });
      };
    }
  };
  const handleDelete = e => {
    onChange('');
    setInputValue({});
    setFilePath('');
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-upload form-file-container"
  }, /*#__PURE__*/_react.default.createElement("input", {
    name: name,
    type: "file",
    accept: "image/png, image/jpeg, application/pdf",
    onChange: handleChange,
    className: "form-file",
    style: {
      display: 'none'
    },
    onClick: e => {
      e.target.value = '';
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form-file-upload"
  }, text || name))), limitTxt && /*#__PURE__*/_react.default.createElement("div", {
    className: "form-msg form-msg-margin upload-tips"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "design-iconfont"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,5 C8.13400675,5 5,8.13400675 5,12 C5,15.8659932 8.13400675,19 12,19 C15.8659932,19 19,15.8659932 19,12 C19,8.13400675 15.8659932,5 12,5 Z M13,11 L13,17 L11,17 L11,11 L13,11 Z M13,8 L13,10 L11,10 L11,8 L13,8 Z",
    fill: "rgb(204, 204, 204)",
    fillRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("span", null, limitTxt)), inputValue.name && /*#__PURE__*/_react.default.createElement("div", {
    className: "upload-file-swap"
  }, filePath && /*#__PURE__*/_react.default.createElement("svg", {
    className: "upload-img",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "1835",
    width: "32",
    height: "32"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M553.1 509.1l-77.8 99.2-41.1-52.4c-3.2-4.1-9.4-4.1-12.6 0l-99.8 127.2c-4.1 5.2-0.4 12.9 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174c-3.3-4.1-9.5-4.1-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z m494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326z m1.8 562H232V136h302v216c0 23.2 18.8 42 42 42h216v494z",
    "p-id": "1836"
  })), /*#__PURE__*/_react.default.createElement("span", null, inputValue.name || ''), /*#__PURE__*/_react.default.createElement("span", {
    className: "file-del",
    onClick: handleDelete
  }, "x")));
}
const UploadInput = ({
  name,
  required,
  onChange,
  data,
  placeholder,
  uploadTxtObj
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)({
    'intl-form-item': true,
    'rno-form-item': true,
    'rno-form-required': required,
    'rno-form-status-error': data.isError
  })
}, /*#__PURE__*/_react.default.createElement("label", {
  className: "form-component-label-s"
}, name, required && /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("div", {
  className: "rno-form-controls"
}, /*#__PURE__*/_react.default.createElement(Upload, {
  name: name,
  onChange: onChange,
  className: "report-form-input",
  placeholder: placeholder,
  uploadTxtObj: uploadTxtObj,
  "report-event": "click_tableForm_upload"
}), /*#__PURE__*/_react.default.createElement("div", {
  className: "rno-form-message"
}, data.errMsg || '')));
var _default = exports.default = UploadInput;